<div [style.width]="LabelWidth" class="label-control" *ngIf="Label !== null">{{Label}}</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/labels/label/label.html